module["exports"] = [
  "2011-10-12",
  "2012-11-12",
  "2015-11-11",
  "2013-9-12"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/business/credit_card_expiry_dates.js
// module id = 1325
// module chunks = 1